import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { MatDrawer, MatDrawerContent, MatSidenavModule } from "@angular/material/sidenav";
import { NavigationEnd, Router, RouterModule } from "@angular/router";
import { Subject, takeUntil } from "rxjs";
import { SiteHeaderComponent } from "../../components/site-header/site-header.component";
import { SiteNavComponent } from "../../components/site-nav/site-nav.component";
import { UserService } from "../../../modules/authentication/_services/user.service";
import { AlertService } from "../../services/alert.service";
import { IUserDetails } from "../../../modules/authentication/_interfaces/user.interface";

@Component({
    selector: "app-dashboard-layout",
    standalone: true,
    imports: [RouterModule, MatSidenavModule, SiteHeaderComponent, SiteNavComponent],
    templateUrl: "./dashboard-layout.component.html",
    styleUrls: ["./dashboard-layout.component.scss"],
})
export class DashboardLayoutComponent implements OnInit, OnDestroy {
    @ViewChild(MatDrawer) drawer: MatDrawer;
    @ViewChild(MatDrawerContent) drawerContent: MatDrawerContent;

    userDetails?: IUserDetails;
    isDrawerOpen = true;

    private destroy$ = new Subject<void>();

    constructor(
        private alertService: AlertService,
        private router: Router,
        private userService: UserService,
    ) {}

    ngOnInit(): void {
        this.initNavigationSubscription();
        this.getUserDetails();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    onToggleDrawer(): void {
        this.isDrawerOpen = !this.isDrawerOpen;
        this.drawer.toggle();
    }

    private initNavigationSubscription(): void {
        this.router.events.pipe(takeUntil(this.destroy$)).subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            this.drawerContent.scrollTo({ top: 0, behavior: "smooth" });
        });
    }

    private getUserDetails(): void {
        this.userService.getUserDetails$().subscribe({
            next: (details) => {
                this.userDetails = details;
            },
        });
    }
}
